import React from "react"

//An example of multiple exports from one file
//variable size header

export function H1(props) {
    return (<div className="">   <h1 className="title is-3 my-2">{props.children}</h1> <hr style={{ borderTop: "dashed 1px", margin: "0 0 0.5em" }} />    </div>);
}

export function H2(props) {
    return (<div className=""><h1 className="subtitle is-3 my-2">{props.children}</h1> <hr style={{ borderTop: "dashed 1px", margin: "0 0 0.5em" }} />     </div>);
}

export function H3(props) {
    return (<div className="">   <h1 className="title is-4 my-2">{props.children}</h1><hr style={{ borderTop: "dashed 1px", margin: "0 0 0.5em" }} />     </div>);
}

export function H4(props) {
    return (<div className=""><h1 className="subtitle is-4 my-2">{props.children}</h1> <hr style={{ borderTop: "dashed 1px", margin: "0 0 0.5em" }} />     </div>);
}

export function H5(props) {
    return (<div className="">   <h1 className="title is-5 my-2">{props.children}</h1> <hr style={{ borderTop: "dashed 1px", margin: "0 0 0.5em" }} />    </div>);
}

export function H6(props) {
    return (<div className=""><h1 className="subtitle is-5 my-2">{props.children}</h1> <hr style={{ borderTop: "dashed 1px", margin: "0 0 0.5em" }} />     </div>);
}

export function P(props) {
    return <p style = {{marginBottom: "1em"}}>{props.children} </p>
}